// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/sedi/mie?societaId={id}&commerciale=true',
    requestBody: null,
    response: '{"success":"true","data":[{"id":"number","nome":"string"}]}'
  },
  {
    method: 'GET',
    endpoint: '/api/utenti/selezionabili?societaId={id}',
    requestBody: null,
    response: '{"success":"true","data":[{"id":"number","nome":"string"}]}'
  },
  {
    method: 'GET',
    endpoint: '/api/codici-iva?societaId={id}&attivo=true',
    requestBody: null,
    response: '{"codici":[{"id":"number","codice":"string","descrizione":"string","aliquota":"string","attivo":"boolean","predefinito":"boolean"}]}'
  },
  {
    method: 'POST',
    endpoint: '/api/offerte-capitolato/:id/genera-commessa',
    requestBody: '{"sedeId":"number","responsabileId":"number","codiceIvaDefaultId":"number"}',
    response: '{"success":true,"data":{"commessaId":"number","commessaNumero":"string"}}'
  },
  {
    method: 'GET',
    endpoint: '/api/sedi/mie?societaId={id}&commerciale=true',
    requestBody: null,
    response: '{"success":true,"data":[{"id":"number","nome":"string"}]}'
  },
  {
    method: 'GET',
    endpoint: '/api/offerte-capitolato?societaId={id}&sedeId={sedeId}&q={q}&stato={stato}',
    requestBody: null,
    response: '{"success":true,"data":[{"id":"number","codice":"string","stato":"string","oggetto":"string","clienteNome":"string","sedeId":"number","sede":{"id":"number","nome":"string"},"_count":{"righe":"number"},"commesse":[]}]}'
  },
  {
    method: 'DELETE',
    endpoint: '/api/offerte-capitolato/:id',
    requestBody: null,
    response: '{"success":true}'
  },
  {
    method: 'GET',
    endpoint: '/api/offerte-capitolato/:id',
    requestBody: null,
    response: '{"success":true,"data":{"id":"number","righe":[],"righeAccessorie":[],"ricarico":"string","tipoFatturazione":"string"}}'
  },
  {
    method: 'PUT',
    endpoint: '/api/offerte-capitolato/:id',
    requestBody: '{"stato":"string","oggetto":"string","clienteNome":"string","ricarico":"number","tipoFatturazione":"string","righe":[],"righeAccessorie":[]}',
    response: '{"success":true}'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
